module.exports = __webpack_public_path__ + "static/vot-fireworks-b742552812e4c27d0175f4f72e870ad9.mp4";